// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-7401e63a],img[data-v-7401e63a]{margin:auto}img[data-v-7401e63a]{top:0;bottom:0;right:0;left:0;max-height:100%;max-width:100%;width:auto!important;height:auto!important;-webkit-user-drag:none}img[data-v-7401e63a]:not(.no-positioning){position:absolute}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
